import config from '@/config';
import {
  getCaptcha,
  getConfig,
  getReportMailSupport,
  isTrialVersion,
  setConfig,
} from '@/tool/profile';

import {
  SET_SYSTEM_COMM_VERSION,
  SET_SYSTEM_DISABLE_COMM_UPDATER,
  SET_SYSTEM_INFO,
  SET_SYSTEM_THEME,
  SET_SYSTEM_TRIAL_NOTICE_VISIBLE,
  SET_SYSTEM_WIDE_SCREEN,
} from '../constants/SystemConstants';

const initialState = {
  // 系统是否进行个性化的标志;
  flag: 0,
  appName: '',
  appTitle: '',
  appProducer: '',
  appLogo: '',
  appUrl: '',

  // 是否支持访客模式
  guest: false,

  // TODO: 需不需要在获取系统定制信息成功手，手动存储至localStorage，以便下次初始化时直接读取，防止出现网络慢，相关内容为空的情况；

  trialNoticeVisible: isTrialVersion(),

  // 验证码状态，0不使用，1图片输入，其他待定
  captcha: getCaptcha(),
  // 支持发邮件
  reportMail: getReportMailSupport(),

  commVersion: '',
  // 通讯组件升级提醒
  disableCommUpdater: getConfig().disableCommUpdater || false,

  // 主题
  theme: getConfig().theme || 'dark',

  // 宽屏模式
  wideScreen:
    typeof getConfig().wideScreen === 'boolean' ? getConfig().wideScreen : config.wideScreen,

  // 集成模式
  integrationScreen: getConfig().integrationScreen || config.integrationScreen,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_SYSTEM_INFO:
      const {
        flag,
        appName,
        appTitle,
        appProducer,
        appLogo,
        appUrl,
        guest,
        captcha,
        reportMail,
        multi,
        mailenabled,
        customized,
        keycabinetLogo,
        keycabinetName,
        edition,
        bititle,
      } = action.payload;
      return {
        ...state,

        flag,
        appName,
        appTitle,
        appProducer,
        appLogo,
        appUrl,
        keycabinetLogo,
        keycabinetName,

        guest,

        captcha,
        reportMail,
        multi,
        mailenabled,
        customized,
        edition,
        bititle,
      };
    case SET_SYSTEM_TRIAL_NOTICE_VISIBLE:
      return {
        ...state,

        trialNoticeVisible: action.payload,
      };

    case SET_SYSTEM_COMM_VERSION:
      return {
        ...state,
        commVersion: action.payload,
      };
    case SET_SYSTEM_DISABLE_COMM_UPDATER:
      setConfig(Object.assign(getConfig(), { disableCommUpdater: action.payload }));
      return {
        ...state,
        disableCommUpdater: action.payload,
      };

    case SET_SYSTEM_THEME:
      setConfig(Object.assign(getConfig(), { theme: action.payload }));
      return {
        ...state,
        theme: action.payload,
      };

    case SET_SYSTEM_WIDE_SCREEN:
      setConfig(Object.assign(getConfig(), { wideScreen: action.payload }));
      return {
        ...state,
        wideScreen: action.payload,
      };
    default: {
      return state;
    }
  }
}
